import React from 'react'
import _ from 'lodash'
import {
  $DCprimaryColor,
  DcButton,
  DcDropDown,
  DcFlexBox,
  DcInput,
  DcSwitch,
  DcText,
  PixelCheckboxGroup,
  PixelCurrency,
  PixelFactoryContext,
  Section,
  DcForm,
} from 'pixel-base'
import styled from 'styled-components'

import { addNewComplaint } from 'utils/api-routes.util'

import {
  IPixelFactory,
  OrderDetail,
  IState,
  LineItem,
} from '../../../../../../decl.d'
import OrderProduct from '../OrderProduct'
import ComplaintProductLineEdit from '../subComponents/common/ComplaintProductLineEdit'

const getLineItemProductId = (lineItem: LineItem): number | null => {
  const id = lineItem.variation_id || lineItem.product_id
  return id ? Number(id) : null
}

interface IProps {
  SetShowOrderDetailModal: (show: boolean) => void
  handleClose: () => void
  detailID: number
  order: OrderDetail
  state: IState
  setDetails: (details: OrderDetail) => void
}
const AddComplaint = (props: IProps) => {
  const ComplaintSection = true

  const { showPageLoader, hidePageLoader, showSuccess, showFailure } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const {
    SetShowOrderDetailModal,
    handleClose,
    detailID,
    order,
    state,
    setDetails,
  } = props

  const [exchangeAble, setExchangeAble] = React.useState(false)
  const [shippingMethod, setShippingMethod] = React.useState([])
  const [error, setError] = React.useState({
    error: '',
    field: '',
  })
  const [complaintData, setComplaintData] = React.useState<{
    complaint_note: string
    complaint_type: string
    exchange_products: any[]
    exchange_shipping: { method: any; total: number }
    exchange_total: number
    order_id: number | null
    products: {
      image: string
      name: string
      price: string
      product_id: number | null
      refund_amount: number
      resolution_type: string
      selected: boolean
      sku: string
    }[]
    refund_amount: number | null
    resolution_type: string
    return_expected: string | number
    method_id: string | null
    status: string
  }>({
    complaint_note: '',
    complaint_type: 'product',
    exchange_products: [],
    exchange_shipping: {
      method: {
        description: '',
        id: '',
        last_synced_at: '',
        source: '',
        store_id: '',
        title: '',
      },
      total: 0,
    },
    exchange_total: 0,
    order_id: null,
    products: [],
    refund_amount: 0,
    resolution_type: 'refund',
    return_expected: 'true',
    method_id: null,
    status: 'new',
  })
  React.useEffect(() => {
    if (
      complaintData?.products?.find(
        (product) => product.resolution_type === 'exchange',
      )
    ) {
      setComplaintData({
        ...complaintData,
        refund_amount: 0,
      })
    } else {
      setComplaintData({
        ...complaintData,
        refund_amount: 0,
      })
    }
  }, [complaintData.products])

  React.useEffect(() => {
    setComplaintData({
      ...complaintData,
      order_id: order?.number,
      refund_amount: complaintData.refund_amount,
      products: order?.line_items?.map((lineItem: LineItem) => {
        return {
          image: lineItem.image,
          name: lineItem.name,
          price: lineItem.price,
          product_id: getLineItemProductId(lineItem),
          refund_amount: lineItem.total,
          resolution_type: 'refund',
          selected: false,
          sku: lineItem.sku,
        }
      }),
    })
  }, [order])

  React.useEffect(() => {
    setShippingMethod(state?.shippingMethods)
  }, [state])

  const handleSubmit = () => {
    handleAddNewComplaint()
  }

  const handleAddNewComplaint = () => {
    showPageLoader()
    if (
      complaintData.complaint_type === 'product' &&
      complaintData.return_expected === 'true'
    ) {
      if (
        !complaintData.products.some((product) => product.selected === true)
      ) {
        showFailure(
          'Select at least one product which is expected to be returned',
        )
        hidePageLoader()
      } else if (
        complaintData.products.some(
          (product) => product.selected && !product.product_id,
        )
      ) {
        const missingSku = complaintData.products.find(
          (product) => product.selected && !product.product_id,
        )?.sku
        showFailure(
          missingSku
            ? `Product ID is missing for SKU ${missingSku}. Please refresh the order and try again.`
            : 'Product ID is missing for one or more selected items.',
        )
        hidePageLoader()
      } else {
        addNewComplaint(complaintData).subscribe((res: any) => {
          hidePageLoader()

          if (res.response.message) {
            handleClose(res.response)
            showSuccess(res.response?.message)
            SetShowOrderDetailModal(false)
          } else {
            if (res.response.error && res.response.field) {
              setError({
                error: res.response.error,
                field: res.response.field,
              })
            } else {
              showFailure(res.response.error)
            }
          }
        })
      }
    } else {
      const data = {
        complaint_note: complaintData.complaint_note,
        complaint_type: complaintData.complaint_type,
        exchange_products: complaintData.exchange_products,
        exchange_shipping: complaintData.exchange_shipping,
        order_id: complaintData.order_id,
        products: [],
        refund_amount: complaintData.refund_amount,

        resolution_type:
          complaintData.resolution_type === 'partial_refund'
            ? 'refund'
            : complaintData.resolution_type,
        return_expected: complaintData.return_expected,
        method_id: complaintData.method_id,
        status: complaintData.status,
        exchange_total: exchangeProduct(),
      }
      addNewComplaint(data).subscribe((res: any) => {
        hidePageLoader()

        if (res.response.message) {
          showSuccess(res.response?.message)
          handleClose(res.response?.message)
        } else {
          if (res.response.error && res.response.field) {
            setError({
              error: res.response.error,
              field: res.response.field,
            })
          } else {
            showFailure(res.response.error)
          }
        }
      })
    }
  }
  const exchangeProduct = () => {
    let exchangeProductsAmmount = 0
    const exchangeProducts = complaintData.exchange_products.map(
      (product: any) => {
        return product.price
      },
    )
    // plus  all array numbers
    exchangeProductsAmmount = exchangeProducts.reduce(
      (acc, curr) => Number(acc) + Number(curr),
      0,
    )
    exchangeProductsAmmount =
      Number(exchangeProductsAmmount) +
      Number(complaintData.exchange_shipping.total)

    return exchangeProductsAmmount
  }
  exchangeProduct()
  const handleShippingMethod = (value) => {
    const shippingMethod = state?.shippingMethods.find(
      (method: any) => method.id === value,
    )
    setComplaintData({
      ...complaintData,
      exchange_shipping: {
        ...complaintData.exchange_shipping,
        method: shippingMethod,
      },
    })
  }
  return (
    <DcForm
      condition={{
        height: exchangeAble ? 'calc(100vh - 120px)' : 'auto',
        overflow: exchangeAble ? 'auto' : 'hidden',
      }}
      onSubmit={handleSubmit}
    >
      <DcFlexBox
        height="auto"
        flexDirection={'column'}
        style={{ overflow: 'auto' }}
      >
        <Section noPadding>
          <InnerSection>
            <FormGroup direction>
              <SectionContents>
                <Title>What is the complaint about?</Title>
              </SectionContents>
              <SectionContents>
                <PixelCheckboxGroup
                  options={[
                    {
                      label: 'Product',
                      value: 'product',
                      type: 'radio',
                      checked: complaintData.complaint_type === 'product',
                    },
                    {
                      label: 'Service',
                      value: 'service',
                      type: 'radio',
                      checked: complaintData.complaint_type === 'service',
                    },
                    {
                      label: 'Courier',
                      value: 'courier',
                      type: 'radio',
                      checked: complaintData.complaint_type === 'courier',
                    },
                  ]}
                  onChange={(e) => {
                    setComplaintData({
                      ...complaintData,
                      complaint_type: e.target.value,
                    })
                  }}
                />
              </SectionContents>
            </FormGroup>
          </InnerSection>
          {complaintData.complaint_type === 'product' && (
            <>
              <InnerSection>
                <FormGroup>
                  <SectionContents>
                    <Title>Is return required?</Title>
                  </SectionContents>
                  <SectionContents>
                    <DcSwitch
                      onChange={(e) => {
                        setComplaintData({
                          ...complaintData,

                          return_expected: e.target.checked ? 'true' : 0,
                        })
                        if (e.target.checked) {
                          const type = _.groupBy(
                            complaintData.products,
                            'resolution_type',
                          )
                          setExchangeAble(Object.keys(type)[0] === 'exchange')
                        } else {
                          setExchangeAble(
                            complaintData.resolution_type === 'exchange',
                          )
                        }
                      }}
                      checked={complaintData.return_expected === 'true'}
                      label={
                        complaintData.return_expected === 'true' ? 'Yes' : 'No'
                      }
                    />
                  </SectionContents>
                </FormGroup>
              </InnerSection>
              {complaintData.return_expected === 'true' ? (
                <>
                  <InnerSection>
                    <FormGroup direction>
                      <SectionContents>
                        <Title>Select items expected to be returned</Title>
                      </SectionContents>
                      {complaintData.products?.length && (
                        <>
                          {complaintData.products?.map((item, index) => {
                            return (
                              <React.Fragment key={index}>
                                <LineItemsContainer>
                                  <PixelCheckboxGroup
                                    key={item.sku}
                                    options={[
                                      {
                                        value: item.selected,
                                        type: 'checkbox',
                                        checked: item.selected,
                                      },
                                    ]}
                                    onChange={(e) => {
                                      setComplaintData({
                                        ...complaintData,
                                        products: complaintData.products.map(
                                          (product) => {
                                            if (product.sku === item.sku) {
                                              return {
                                                ...product,
                                                selected: e.target.checked,
                                              }
                                            }
                                            return product
                                          },
                                        ),
                                      })
                                    }}
                                  />
                                  <SectionSpan>
                                    {item.name} ({item.sku})
                                  </SectionSpan>
                                </LineItemsContainer>
                              </React.Fragment>
                            )
                          })}
                          {complaintData.products.find(
                            (item) => item.selected,
                          ) && (
                            <ChangeResType>
                              <ComplaintProductLineEdit
                                setExchangeAble={setExchangeAble}
                                setData={setComplaintData}
                                data={complaintData}
                                item={complaintData.products.find(
                                  (item) => item.selected,
                                )}
                              />
                            </ChangeResType>
                          )}
                        </>
                      )}
                    </FormGroup>
                  </InnerSection>
                </>
              ) : (
                <>
                  <InnerSection>
                    <FormGroup direction>
                      <SectionContents>
                        <Title>How to resolve the complaint?</Title>
                      </SectionContents>
                      <PixelCheckboxGroup
                        options={[
                          {
                            label: 'refund',
                            value: 'refund',
                            type: 'radio',
                            checked: complaintData.resolution_type === 'refund',
                          },
                          {
                            label: 'exchange',
                            value: 'exchange',
                            type: 'radio',
                            checked:
                              complaintData.resolution_type === 'exchange',
                          },
                        ]}
                        onChange={(e) => {
                          setComplaintData({
                            ...complaintData,
                            resolution_type: e.target.value,
                          })
                          if (e.target.value === 'exchange') {
                            setExchangeAble(true)
                          } else {
                            setExchangeAble(false)
                          }
                        }}
                      />
                      {complaintData.resolution_type === 'refund' && (
                        <DcInput
                          error={
                            error.field === 'refund_amount' &&
                            error.error !== ''
                              ? error.error
                              : null
                          }
                          required
                          type={'number'}
                          name={'amount'}
                          placeholder={'Refund amount'}
                          value={complaintData.refund_amount}
                          onChange={(e) =>
                            setComplaintData({
                              ...complaintData,
                              refund_amount: e.target.value,
                            })
                          }
                        />
                      )}
                    </FormGroup>
                  </InnerSection>
                </>
              )}
            </>
          )}

          <InnerSection>
            <FormGroup direction>
              <SectionContents>
                <Title>Additional details</Title>
              </SectionContents>

              <DcInput
                errorMessage={'Enter complaint details'}
                isShowError={complaintData.complaint_note.length <= 0}
                error={
                  error.field === 'description' && error.error !== ''
                    ? error.error
                    : null
                }
                required
                type={'text'}
                as={'textarea'}
                name={'description'}
                placeholder={'Enter complaint details'}
                value={complaintData.complaint_note}
                onChange={(e) =>
                  setComplaintData({
                    ...complaintData,
                    complaint_note: e.target.value,
                  })
                }
              />
            </FormGroup>
          </InnerSection>
        </Section>

        {exchangeAble && (
          <>
            <Section noPadding style={{ borderLeft: '1px solid #e6e6e6' }}>
              <InnerSection>
                <FormGroup direction>
                  <SectionContents>
                    <Title>New Order</Title>
                  </SectionContents>
                  <FormGroup direction>
                    <SectionContents>
                      <SectionSpan>
                        Exchange Order Total:
                        <strong>
                          <PixelCurrency value={exchangeProduct()} />
                        </strong>
                      </SectionSpan>
                    </SectionContents>

                    <SectionContents>
                      <PixelCheckboxGroup
                        label={''}
                        options={[
                          {
                            label:
                              'Hold exchange order until the return receives from the customer.',
                            value: 'hold',
                            type: 'checkbox',
                            checked: true,
                          },
                        ]}
                      />
                    </SectionContents>
                  </FormGroup>
                </FormGroup>
              </InnerSection>
              <InnerSection>
                <FormGroup direction>
                  <SectionContents>
                    <Title>Exchange Order Details</Title>
                  </SectionContents>
                  <FormGroup direction>
                    <DcDropDown
                      error={
                        error.field === 'role_id' && error.error !== ''
                          ? error.error
                          : null
                      }
                      options={[
                        { title: 'Select Shipping Method', id: '' },
                        ...shippingMethod,
                      ].map((data) => {
                        return {
                          label: data.title,
                          value: data.id,
                        }
                      })}
                      placeholder={'  Select Shipping Method'}
                      name={' Select Shipping Method'}
                      value={
                        complaintData.method_id
                          ? ''
                          : complaintData.exchange_shipping.method.id
                      }
                      onChange={(e) => {
                        handleShippingMethod(e.target.value)
                      }}
                    />
                    <DcInput
                      error={
                        error.field === 'complaintData.exchange_shipping' &&
                        error.error !== ''
                          ? error.error
                          : null
                      }
                      required
                      type={'number'}
                      name={'amount'}
                      value={complaintData.exchange_shipping.total}
                      placeholder={'Shipping Charges'}
                      onChange={(e) => {
                        setComplaintData({
                          ...complaintData,
                          exchange_shipping: {
                            ...complaintData.exchange_shipping,
                            total: e.target.value,
                          },
                        })
                      }}
                    />
                  </FormGroup>
                </FormGroup>
              </InnerSection>
              <OrderProduct
                detailID={detailID}
                setDetails={setDetails}
                details={order}
                data={complaintData}
                setData={setComplaintData}
                ComplaintSection={ComplaintSection}
              />

              <DcFlexBox
                justifyContent="space-between"
                alignItems="center"
                height="auto"
              >
                <DcText className="h4">Total</DcText>
                <PixelCurrency value={exchangeProduct()} />
              </DcFlexBox>
            </Section>
          </>
        )}
      </DcFlexBox>
      <FormGroup flexEnd>
        <DcButton
          size="sm"
          onClick={() => {
            handleClose()
          }}
          variant="outline-secondary"
        >
          Close
        </DcButton>
        <DcButton
          size="sm"
          variant="primary"
          type="button"
          onClick={handleSubmit}
        >
          Create
        </DcButton>
      </FormGroup>
    </DcForm>
  )
}

const ChangeResType = styled.div`
  margin-left: 20px;
`
const LineItemsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`
const InnerSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: center;
  border-bottom: 1px solid #e6e6e6;
  width: 100%;
  padding: 18px 18px;
`

const FormGroup = styled.div<{ flexEnd?: boolean; direction?: boolean }>`
  display: inline-flex;
  flex-direction: ${(props) => (props.direction ? 'column' : 'row')};
  flex-wrap: nowrap;
  justify-content: ${(props) => (props.flexEnd ? 'flex-end' : 'space-between')};
  align-items: stretch;
  align-content: flex-start;
  width: 100%;
  height: auto;
  gap: 12px;
  .full-width {
    flex-grow: 1;
  }
`
const SectionContents = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: flex-start;
  align-content: center;
`
const Title = styled.div`
  color: rgba(0, 0, 0, 0.87);
  font-size: 16px;
  font-weight: 600;
  align-self: inherit;
`
const SectionSpan = styled.div<{ color?: string }>`
  font-size: 12px;
  font-weight: 400;
  color: ${(props) =>
    props.color === 'primary' ? $DCprimaryColor : 'rgba(0, 0, 0, 0.87)'};
`

export default AddComplaint
